import { render, staticRenderFns } from "./ImpresionFormularios.vue?vue&type=template&id=2addf20c"
import script from "./ImpresionFormularios.vue?vue&type=script&lang=js"
export * from "./ImpresionFormularios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports